import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'virtues-bootstrap';

import s from './styles.module.scss';

const AppLoading = ({ children, loading }) => {
  if (loading) {
    return (
      <div className={s.appLoading}>
        <Loading />
      </div>
    );
  }

  return children;
};

AppLoading.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AppLoading;
